import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { TextButton } from '@components/library/button/index';
import RulesRow from './rules_row';
import RuleModal from './rules_modal/main';

import './styles/main.scss';

function RulesManagement(props) {
  const { rules } = props;
  const [showModal, toggleModal] = useState(false);
  const [editableRule, setEditableRule] = useState(null);
  const [queryString, setQueryString] = useState('');
  const [visibleRules, setVisibleRules] = useState(rules);

  useEffect(() => {
    const matchingRules = [];
    const queryMatches = (names) => (
      names.toLowerCase().indexOf(queryString.toLowerCase()) > -1
    );
    for (let i = 0; i < rules.length; i += 1) {
      if (queryMatches(rules[i].actionable_names) || queryMatches(rules[i].scopable_names)) {
        matchingRules.push(rules[i]);
      }
    }
    setVisibleRules(matchingRules);
  }, [rules, queryString]);

  const updateSearch = (event) => {
    setQueryString(event.target.value);
  };

  const resetShowModal = () => {
    toggleModal(false);
    setEditableRule(null);
  };

  return (
    <div className="manage-rules">
      <h2>{t('Rules for')} {BF.fx.brandfolder().name}</h2>
      <hr />
      <TextButton className="add-rule" icon="bff-plus" onClick={() => toggleModal(true)}>
        {t('Add Rule')}
      </TextButton>
      <div className="manage-rules-searchbar">
        <input
          className="bf-input searchbar"
          id="custom-fields-search"
          onChange={updateSearch}
          placeholder={t(`Search ${props.rules.length} rules`)}
          type="text"
        />
      </div>
      <div className="headers">
        <h3 className="fifteen">{t("Rule")}</h3>
        <h3 className="thirty">{t("Trigger")}</h3>
        <h3 className="twenty">{t("Action")}</h3>
        <h3 className="ten center">{t("Enforce")}</h3>
        <h3 className="ten center">{t("Created")}</h3>
        <div className="fifteen center" />
        <div className="five" />
        <div className="five" />
      </div>
      { visibleRules.map((rule) => (
        <div className="rule-row" key={rule.key}>
          <RulesRow rule={rule} setEditMode={() => setEditableRule(rule)} />
        </div>
      ))
      }
      {(showModal || editableRule) && <RuleModal ruleData={editableRule} resetShowModal={resetShowModal} />}
    </div>
  );
}

RulesManagement.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RulesManagement;
